import Typography from "@/src/views/components/Typography";
import { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import { WordStyling } from "@/src/types/landingPage";

export default function CardLayanan({
  src,
  id,
  field,
  desc,
  listWordStyling,
  transitionDelay,
}: {
  src?: string;
  id?: string;
  field?: string;
  desc?: string;
  listWordStyling?: WordStyling[];
  transitionDelay?: string;
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    containerRef,
  ]);
  
  return (
    <div
      ref={containerRef}
      id={id}
      className={styles["service-box"]}
      style={{
        transitionDelay: transitionDelay
      }}
    >
      <img
        src={src}
        width={65}
        // height={100}
      />
      <Typography
        fontStyle={
          ["machine learning", "advance ai"]?.includes(field?.toLowerCase())
            ? "italic"
            : "default"
        }
        variant="subtitle-5-bold"
        color="black"
      >
        {field}
      </Typography>
      <Typography variant="title-4-medium" color="dark10" listWordStyling={listWordStyling}>
        {desc}
      </Typography>
    </div>
  );
}
